import { Component } from '@angular/core'
import { HeaderComponent } from '../header/header.component'
import { RouterOutlet } from '@angular/router'

@Component({
    selector: 'app-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    imports: [HeaderComponent, RouterOutlet],
    standalone: true,
})
export class AppLayoutComponent {}
